import React, { useState } from "react";
import { adminApi } from "../../../../../../services";
import { useNavigate } from "react-router-dom";
import UserSearchCard from "../../../../../../components/common/UserSearchCard";

export default function CreateLoan() {
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [form, setForm] = useState({
    principalAmount: "",
    tenureMonths: "",
    startDate: "",
  });

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!user) return alert("Search user first");

  //   try {
  //     await adminApi.createLoan({
  //       userId: user._id,
  //       ...form,
  //     });

  //     alert("Loan created");
  //     navigate("/admin-dashboard/loans");
  //   } catch (err) {
  //     alert(err.response?.data?.message || "Error");
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!user) {
      return alert("Please search user first");
    }
  
    try {
      const res = await adminApi.createLoan({
        userId: user._id,
        ...form,
      });
  
      const createdLoan = res?.data?.data;
  
      alert("Loan created successfully");
  
      // ✅ PRINT FLOW
      if (window.confirm("Do you want to print the loan details?")) {
        navigate("/admin-dashboard/print", {
          state: {
            type: "loan",
            data: createdLoan,
            returnTo: "/admin-dashboard/loans"
          },
        });
      } else {
        navigate("/admin-dashboard/loans");
      }
  
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Failed to create Loan");
    }
  };
  return (
    <div className="container">
      <h2>Create Loan</h2>

      <UserSearchCard
        getUser={adminApi.getUserByAccountNumber}
        onUserFound={setUser}
      />

      {user && (
        <form onSubmit={handleSubmit} className="mt-3">
          <input
            className="form-control mb-2"
            placeholder="Amount"
            onChange={(e) =>
              setForm({ ...form, principalAmount: e.target.value })
            }
          />

          <input
            className="form-control mb-2"
            placeholder="Tenure (Months)"
            onChange={(e) =>
              setForm({ ...form, tenureMonths: e.target.value })
            }
          />

          <input
            type="date"
            className="form-control mb-2"
            onChange={(e) =>
              setForm({ ...form, startDate: e.target.value })
            }
          />

          <button className="btn btn-primary w-100">Create Loan</button>
        </form>
      )}
    </div>
  );
}
